"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
function Toggle({ active = false, disabled = false, icon, title, variant, onUpdate, }) {
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.Toggle, { icon: icon, active: active, title: title, size: "Small", onClick: (active) => onUpdate(active), disabled: disabled, children: variant === 'title' && title }));
}
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map